import React from 'react'

export const Instructions = (): JSX.Element => {
  return <div>Here are some instructions for my lovely app</div>
}
